module.exports = __webpack_public_path__ + "img/BasedowKonzert.322ecba4.jpg";